const getChatRecipientName = (item: any) => {
  const source = item?.claim || item;

  if (source?.chattedWith?.nickname) {
    return source.chattedWith.nickname;
  }

  if (source?.tribe?.name) {
    return source.tribe.name;
  }

  if (source?.groupChat?.name) {
    return source.groupChat.name;
  }

  return '-';
};

export default getChatRecipientName;
